import dayjs from 'dayjs'
import ReferralStatusEnum from '../enums/ReferralStatusEnum'

export default {
    methods: {
        isReferralPending(referral) {
            return !!referral && [ReferralStatusEnum.CREATED].includes(referral.status)
        },

        isReferralPendingReschedule(referral) {
            return (
                !!referral &&
                [ReferralStatusEnum.RESCHEDULE_REQUESTED, ReferralStatusEnum.RESCHEDULE_REQUESTED_BY_PATIENT].includes(
                    referral.status,
                )
            )
        },

        isReferralToBeRescheduled(referral) {
            return !!referral && [ReferralStatusEnum.RESCHEDULE_AVAILABILITY_CHANGE].includes(referral.status)
        },

        isReferralOk(referral) {
            return (
                !!referral &&
                [
                    ReferralStatusEnum.PATIENT_VISIT_PENDING,
                    ReferralStatusEnum.INSURANCE_AUTH_PENDING,
                    ReferralStatusEnum.CONSULTATION_NOTES_PENDING,
                    ReferralStatusEnum.TIME_SLOTS_PROPOSED,
                ].includes(referral.status)
            )
        },

        isReferralConfirmed(referral) {
            return (
                !!referral &&
                (referral.status === ReferralStatusEnum.INSURANCE_AUTH_PENDING ||
                    (referral.approveDateTime && dayjs(referral.approveDateTime).isValid()))
            )
        },

        isReferralWaitingForInsurance(referral) {
            return !!referral && referral.status === ReferralStatusEnum.INSURANCE_AUTH_PENDING
        },

        isInsuranceObtained(referral) {
            return !!referral.insuranceAuthorizationObtainedDateTime
        },

        isInsuranceDeclined(referral) {
            return referral.closeReason === 'INSURANCE_AUTH_DENIED'
        },

        isReferralWaitingForPatient(referral) {
            return !!referral && referral.status === ReferralStatusEnum.PATIENT_VISIT_PENDING
        },

        isReferralWaitingForReport(referral) {
            return !!referral && referral.status === ReferralStatusEnum.CONSULTATION_NOTES_PENDING
        },

        isReferralCompleted(referral) {
            return !!referral && !![ReferralStatusEnum.COMPLETED, ReferralStatusEnum.SCHEDULED].includes(referral.status)
        },

        isReferralError(referral) {
            return this.isReferralDeclined(referral) || this.isReferralCancelledOrNoShow(referral)
        },

        isReferralDeclined(referral) {
            return !!referral && [ReferralStatusEnum.DECLINED].includes(referral.status)
        },

        isReferralCancelledOrNoShow(referral) {
            return (
                !!referral &&
                [ReferralStatusEnum.NO_SHOW, ReferralStatusEnum.CANCELLED, ReferralStatusEnum.INACTIVE].includes(referral.status)
            )
        },

        isReferralFinished(referral) {
            return !!referral && referral.state === 'CLOSED'
        },

        isReferralPendingOrReschedule(referral) {
            return (
                !!referral &&
                (referral.status === ReferralStatusEnum.CREATED || referral.status === ReferralStatusEnum.RESCHEDULE_REQUESTED)
            )
        },

        shouldShowReferralDetails(referral) {
            return (
                !!referral &&
                referral.shouldShowPatientInfo &&
                ![
                    ReferralStatusEnum.CANCELLED,
                    ReferralStatusEnum.NO_SHOW,
                    ReferralStatusEnum.CONSULTATION_NOTES_PENDING,
                    ReferralStatusEnum.DECLINED,
                ].includes(referral.status)
            )
        },
        isReferralReschedulable(referral) {
            return (
                !!referral &&
                [
                    ReferralStatusEnum.DECLINED,
                    ReferralStatusEnum.CANCELLED,
                    ReferralStatusEnum.PATIENT_VISIT_PENDING,
                    ReferralStatusEnum.CONSULTATION_NOTES_PENDING,
                    ReferralStatusEnum.NO_SHOW,
                    ReferralStatusEnum.COMPLETED,
                ].includes(referral.status)
            )
        },
    },
}
